import React, { Component, Fragment } from "react";
import _ from "lodash";
// import Image1 from "../../images/settings.png";
// import Image2 from "../../images/Waiting.png";
// import Image3 from "../../images/delete.png";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import getData from "./../data-services/api";
import { withRouter } from "react-router-dom";
import './ImageSlider.css';



class ImageSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            workshops: [],
            userData: {}
        };
    }

    async componentDidMount() {
        Promise.all([
            getData(
                `Select id, Name, Sequence__c, Url__c, systemmodstamp from salesforce.News_Dashboard__c`
            )
        ]).then(([carouselData, ...data]) => {
            this.setState({
                carouselData: carouselData.result,
                loading: false
            });
            // console.log("inside getimage", carouselData);
        });

    }

    render() {

        return(
        <>
            <Carousel infiniteLoop autoPlay showThumbs={false} interval={3000}>
                {this.state.carouselData && this.state.carouselData.map((item) => {
                    return (
                        <div>
                            <img src={item.url__c} />
                        </div>
                    )
                })}
            </Carousel>
        </>
        )
    }
}

export default withRouter((ImageSlider));